import { all, call, cancelled, put, spawn, takeLatest, takeLeading } from 'redux-saga/effects';
import { ReduxAction } from 'types/redux.types';
import userActions from '../user/actions';
import actions from './actions';
import fetchCandidateSearchRole from './graphql';

function* fetchCandidateSearchRoleGenerator(action: ReduxAction): any {
  try {
    const response = yield call(fetchCandidateSearchRole);
    yield put({
      type: actions.FETCH_CANDIDATE_SEARCH_ROLE_DONE,
      payload: response.data.candidateSearchRole,
    });
  } catch (e: any) {
    log(e);
    yield put({
      type: actions.FETCH_CANDIDATE_SEARCH_ROLE_ERROR,
    });
  } finally {
    if (yield cancelled()) {
      yield put({
        type: actions.FETCH_CANDIDATE_SEARCH_ROLE_CANCELLED,
      });
    }
  }
}

function* fetchRoleAfterUserLoads() {
  yield takeLeading([userActions.USER_LOADED], fetchCandidateSearchRoleGenerator);
}

function* fetchRoleFromActionStart() {
  yield takeLatest([actions.FETCH_CANDIDATE_SEARCH_ROLE_START], fetchCandidateSearchRoleGenerator);
}

export default function* rootSaga() {
  yield all([spawn(fetchRoleAfterUserLoads), spawn(fetchRoleFromActionStart)]);
}
